/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <kpa@giap.pl>, November 2022
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import { Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { FiCheck, FiX } from 'react-icons/fi';
import _ from 'lodash';
import { multiPolygon, intersect, buffer, polygon, point } from '@turf/turf';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import CustomizedMap from './CustomizedMap';
import ModalAlert from './ModalAlert';
import fetch from '../../core/fetch/fetch.server';
import waiting from '../../routes/eserviceSummary/waiting-wheel-300x300.gif';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../components/utils/utils';
import { PanelStyle } from '../../constants';
import pans from './panStyle.scss';
import {
  standardMaterialsOptions,
  kartoMaterialsOptions,
  customMaterialsOptions,
  categoriesDict
}
  from './dicts';

const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
} = PanelStyle;


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
  float: 'right',
};

const printedSharingMethod =  'drukowana';
const polygraphicMethod = 'druk poligraficzny';
const blackWhiteFormat = 'czarno-biały';
const colorFormat = 'kolorowy';


class SprDostMaterialow extends React.Component {
  state = {

    listMaterials: [{
      printigAvailabilty: {},
      printingDisabled: false,
      selectedMaterialName: '',
      category: '',
      materialGeoms: {},
      rasterFormats: {},
      selectedRasterFormats: [],
      selectedMaterialsList: [],
      selectionGroups: [],
      highlightedGeoms: [],
      areaSelection: 'jednostki podziału terytorialnego kraju',
      godlo: null,

      voivodeship: null,
      voivodeshipTERYT: null,

      district: null,
      districtTERYT: null,

      community: null,
      communityTERYT: null,
      fetchedCommunities: [],
      communityOptions: [],
      communityTERYTOptions: [],

      town: null,
      townTERYT: null,
      fetchedTowns: [],
      townOptions: [],
      townTERYTOptions: [],

      sharingMethod: '',
      printedSharingMethod: '',
      printedSharingMethodDetails: '',

      listPolygons: [
        {
          X: '',
          Y: '',
        },
        {
          X: '',
          Y: '',
        },
        {
          X: '',
          Y: '',
        },
      ],
      shapefile:
      {
        name: '',
        file: '',
      },
    }],
    otherCustomMaterialsOptions: [],
    otherKartoMaterialsOptions: [],
    otherMaterialsOptions: [],
    allDistricts: [],
    enabledMaterials: [],
    enabledMaterialsDict: {},
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
    selectedParcels: [],
    style: {},
    loading: false,
    enabledSharingMethods: {},
  };


  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    this.fetchStyle();
    this.fetchEnabledMaterials();
    this.fetchDistrictInfo();
  }

  fetchDistrictInfo() {
    const keys = Object.keys(this.props.districts);
    const prefix = keys[0];
    const districtEmail = this.props.districts[prefix].email;
    this.setState({ districtEmail });
  }

  fetchStyle() {
    const colors = getThemeFromLocalStorage();
    let sourceStyle = layoutColorStyle;
    let style = {
      color: sourceStyle[colors].color,
    };
    if (colors !== 'normal') {
      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
      };
    }
    this.setState({ colors, sourceStyle, style });
  }

  fetchEserviceDistrict() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });
  }

  fetchEnabledMaterials() {
    fetch(`${process.env.API_URL}/enabledMaterials/`, {
      method: 'GET',
    })
    .then(r => r.json())
    .then(resp => {
      this.setState({
        enabledMaterials: resp.enabled_materials_names,
        enabledMaterialsDict: resp.enabled_materials_dict,
      }, () => this.setOtherMaterialsDict(resp));
    });
  }

  setOtherMaterialsDict = (resp) => {
    const otherCustomMaterialsOptions = [];
    for (const name of resp.other_custom_materials) {
      otherCustomMaterialsOptions.push({
        label: name,
        value: name,
        state: 'selectedMaterialName',
        category: 3,
      });
    }

    const otherKartoMaterialsOptions = [];
    for (const name of resp.other_karto_materials) {
      otherKartoMaterialsOptions.push({
        label: name,
        value: name,
        state: 'selectedMaterialName',
        category: 4,
      });
    }
    const otherMaterialsOptions = [];
    for (const name of resp.other_materials) {
      otherMaterialsOptions.push({
        label: name,
        value: name,
        state: 'selectedMaterialName',
        category: 5,
      });
    }

    this.setState({ otherCustomMaterialsOptions, otherKartoMaterialsOptions, otherMaterialsOptions });
  }

  fetchMaterialsGeoms(materialName, index) {
    fetch(`${process.env.API_URL}/getMaterialGeoms/?material_name=${encodeURIComponent(materialName)}`, {
      method: 'GET',
    })
    .then(r => r.json())
    .then(resp => {
      const arr = _.cloneDeep(this.state.listMaterials);
      arr[index].materialGeoms = resp.geoms;
      arr[index].rasterFormats = resp.raster_formats;
      this.setState({
        listMaterials: arr,
        loading: false,
      }, () => this.checkPrintingAvailability(materialName, index));
    });
  }

  checkPrintingAvailability(materialName, index) {
    fetch(`${process.env.API_URL}/checkPrintingAvailability/?material_name=${encodeURIComponent(materialName)}`, {
      method: 'GET',
    })
    .then(r => r.json())
    .then(resp => {
      const arr = _.cloneDeep(this.state.listMaterials);
      arr[index].printingDisabled = resp.printing_disabled;
      this.setState({
        listMaterials: arr,
      }, this.getMaterialSharingMethods);
    });
  }

  getMaterialSharingMethods() {
    const materialName = this.state.listMaterials[0].selectedMaterialName;
    const methods = _.cloneDeep(this.state.enabledMaterialsDict[materialName]);
    methods[printedSharingMethod] = !this.state.listMaterials[0].printingDisabled;

    this.setState({ enabledSharingMethods: methods });
  }

  fetchMaterialsIntersection = (unitType, unitTeryt, materialName) => {
    return fetch(`${process.env.API_URL}/checkMaterialIntersection/?unit_type=${encodeURIComponent(unitType)}&unit_teryt=${encodeURIComponent(unitTeryt)}&material_name=${encodeURIComponent(materialName)}`, {
      method: 'GET',
    })
    .then(r => r.json())
    .then(resp => {
      return resp;
    });
  }

  removeSelectionGroup = (idx, selectionGroup) => {
    const list = [...this.state.listMaterials[idx].selectedMaterialsList];
    const matList = [];
    for (const mat of list) {
      if (mat.properties.selectionGroup === selectionGroup) {
        matList.push(mat.properties.name);
      }
    }

    for (const name of matList) {
      this.removeSelectedMaterial(idx, name);
    }
  }

  removeSelectedMaterials = (idx) => {
    const listMaterials = _.cloneDeep(this.state.listMaterials);
    listMaterials[idx].selectedMaterialsList = [];

    this.setState({ listMaterials });
  }

  removeSelectedMaterial = (idx, name) => {
    const arr = _.cloneDeep(this.state.listMaterials);
    const list = arr[idx].selectedMaterialsList;

    let subidx = null;
    for (const mat of list) {
      if (mat.properties.name === name) {
        subidx = list.indexOf(mat);
        break;
      }
    }
    if (subidx !== null && subidx > -1) {
      list.splice(subidx, 1);
    }

    arr[idx].selectedMaterialsList = list;
    arr[idx].highlightedGeoms = [];

    const allSelectiongroups = [];
    for (const mat of list) {
      if (!allSelectiongroups.includes(mat.properties.selectionGroup)) {
        allSelectiongroups.push(mat.properties.selectionGroup);
      }
    }

    let selectionIdx = null;
    for (const selectionType of arr[idx].selectionGroups) {
      if (!allSelectiongroups.includes(selectionType)) {
        selectionIdx = arr[idx].selectionGroups.indexOf(selectionType);
        arr[idx].selectionGroups.splice(selectionIdx, 1);
      }
    }

    this.setState({
      listMaterials: arr,
    });
  }

  onChangeMapMaterial = (e, state, elem, index, cat) => {
    const arr = _.cloneDeep(this.state[state]);
    const value = e.target.value;
    arr[index][elem] = value;
    arr[index].category = categoriesDict[cat];
    arr[index].selectedMaterialsList = [];
    arr[index].selectedRasterFormats = [];

    this.setState({
      [state]: arr,
      loading: true,
    }, () => this.fetchMaterialsGeoms(value, index),
    );
  }

  renderMapRadioButtons = (buttonsList, group, state, index) => {
    const enabledButtons = [];
    for (const button of buttonsList) {
      if (this.state.enabledMaterials.includes(button.value)) {
        enabledButtons.push(button);
      }
    }
    return (
      <div>
        {enabledButtons.length > 0 ? enabledButtons.map((item, idx) => (
          <div key={`mapRadio${item}_${index}_${idx}`} className="radio">
            <label
              style={!this.state.enabledMaterials.includes(item.value) ? { color: 'gray' } : null}
            >
              <input
                disabled={!this.state.enabledMaterials.includes(item.value)}
                type="radio"
                value={item.value}
                name={`${state}#${index}`}
                checked={this.state[group][index][state] === item.value}
                onChange={e => this.onChangeMapMaterial(e, group, state, index, item.category)}
              />
              <b>{`    ${item.label}`}<br /></b>
            </label>
          </div>
        )) : <p>brak aktywnych opracowań</p>}
      </div>);
  };

  addGeomByRectangleIntersection = (idx, startPoint, endPoint) => {
    const coords = [[]];
    coords[0].push([startPoint.lng, startPoint.lat]);
    coords[0].push([startPoint.lng, endPoint.lat]);
    coords[0].push([endPoint.lng, endPoint.lat]);
    coords[0].push([endPoint.lng, startPoint.lat]);

    coords[0].push(coords[0][0]); // trzeba zamknąć poligon - pierwszy vertex = ostatni
    const poly1 = buffer(polygon(coords), 0);
    const selectionGroup = 'Godło arkusza mapy';

    this.checkPolygonIntersection(idx, poly1, selectionGroup);
  }

  addGeomByDrawedPolyIntersection = (idx, coords, pointCount) => {
    if (pointCount > 2) {
      coords[0].push(coords[0][0]); // trzeba zamknąć poligon - pierwszy vertex = ostatni
      const poly1 = buffer(polygon(coords), 0);
      const selectionGroup = 'Godło arkusza mapy';

      this.checkPolygonIntersection(idx, poly1, selectionGroup);
    } else {
      this.setState({
        errorText: 'Wielokąt musi składać się z co najmniej trzech punktów.',
        errorTitle: 'Błędne dane.',
        showError: true,
      });
    }
  }

  checkPolygonIntersection = (idx, poly1, selectionGroup) => {
    let arr = _.cloneDeep(this.state.listMaterials);
    if (Object.keys(this.state.listMaterials[idx].materialGeoms).length !== 0) {
      for (const feature of this.state.listMaterials[idx].materialGeoms.features) {
        const poly2 = buffer(multiPolygon(feature.geometry.coordinates), 0);
        const intersection = intersect(poly2, poly1);
        if (intersection) {
          const godlo = feature.properties.godlo;
          const skala = feature.properties.skala;
          const uklad = feature.properties.uklad;
          const idMaterialu = feature.properties.idMaterialu;
          if (!arr[idx].selectionGroups.includes(selectionGroup)) {
            arr[idx].selectionGroups.push(selectionGroup);
          }
          let availableCount = this.getMaterialAvailability(idx, idMaterialu);
          arr[idx].selectedMaterialsList.push({
            type: 'Feature',
            properties: {
              name: godlo,
              count: (availableCount > 0) ? 1 : 0,
              idMaterialu,
              skala,
              uklad,
              selectionGroup,
            },
            geometry: feature.geometry,
          });
        }
      }
    }

    this.setState({
      listMaterials: arr,
    });
  }

  addGeomByPointIntersection = (idx, latlng) => {
    const coords = [latlng.lng, latlng.lat];
    const point1 = point(coords);

    let arr = _.cloneDeep(this.state.listMaterials);
    if (Object.keys(this.state.listMaterials[idx].materialGeoms).length !== 0) {
      for (const feature of this.state.listMaterials[idx].materialGeoms.features) {
        const poly2 = buffer(multiPolygon(feature.geometry.coordinates), 0);
        const intersection = intersect(poly2, point1);
        if (intersection) {
          const godlo = feature.properties.godlo;
          const skala = feature.properties.skala;
          const uklad = feature.properties.uklad;
          const idMaterialu = feature.properties.idMaterialu;
          const selectionGroup = 'Godło arkusza mapy';
          if (!arr[idx].selectionGroups.includes(selectionGroup)) {
            arr[idx].selectionGroups.push(selectionGroup);
          }
          let availableCount = this.getMaterialAvailability(idx, idMaterialu);
          arr[idx].selectedMaterialsList.push({
            type: 'Feature',
            properties: {
              name: godlo,
              count: (availableCount > 0) ? 1 : 0,
              idMaterialu,
              skala,
              uklad,
              selectionGroup,
            },
            geometry: feature.geometry,
          });
          break;
        }
      }
    }

    this.setState({
      listMaterials: arr,
    });
  }

  getMaterialAvailability = (idx, idMaterialu) => {
    const CURRENT_MATERIAL = this.state.listMaterials[idx];
    if (CURRENT_MATERIAL.sharingMethod !== printedSharingMethod) {
      return 1;
    }

    const availabilty = CURRENT_MATERIAL.printigAvailabilty;
    let key = CURRENT_MATERIAL.printedSharingMethod;
    if (key === polygraphicMethod) {
      key = CURRENT_MATERIAL.printedSharingMethodDetails;
    }

    let availableCount = 0;
    if (idMaterialu in availabilty) {
      if ([blackWhiteFormat, colorFormat].includes(key)) {
        const available = availabilty[idMaterialu][key];
        if (available) {
          availableCount = 1;
        }
      } else {
        availableCount = availabilty[idMaterialu][key];
      }
    }

    if (availableCount < 0) {
      availableCount = 0;
    }
    return availableCount;
  }

  geomExists = (idx, name) => {
    let exists = false;

    for (const geom of this.state.listMaterials[idx].selectedMaterialsList)
      if (name === geom.properties.name) {
        exists = true;
      }

    return exists;
  }

  highlightRowAndGeom = (idx, val) => {
    const arr = _.cloneDeep(this.state.listMaterials);
    if (arr[idx].selectedMaterialsList.length !== 0) {
      for (const feature of arr[idx].selectedMaterialsList) {
        if (val.properties.name === feature.properties.name) {
          arr[idx].highlightedGeoms = [{
            type: 'Feature',
            properties: {
              name: val.properties.name,
              count: 1,
            },
            geometry: feature.geometry,
          }];
        }
      }
    }

    this.setState({
      listMaterials: arr,
    });
  }

  removeHighlight = (idx) => {
    const arr = _.cloneDeep(this.state.listMaterials);
    arr[idx].highlightedGeoms = [];

    this.setState({
      listMaterials: arr,
    });
  }

  renderDeletionButton = (idx) => {
    return (
      <div key={`DeletionButton_${idx}`} className="col-lg-12" style={{ marginBottom: '10px' }}>
        <Col key={`DeletionButton_${idx}_col1`} xs={10} sm={10} md={10} style={{ marginBottom: '10px' }} />
        <Col key={`DeletionButton_${idx}_col2`} xs={2} sm={2} md={2} style={{ marginBottom: '10px' }}>
          <button
            type="submit-lg"
            className={'btn btn-danger'}
            style={{ btnStyle }}
            onClick={() => this.removeSelectedMaterials(idx)}
          >
            Usuń wszystko
          </button>
        </Col>
      </div>
    );
  }

  renderSelectionGroups = (name, subidx, idx) => {
    const selectionGroup = [];

    for (const material of this.state.listMaterials[idx].selectedMaterialsList) {
      if (material.properties.selectionGroup === name) {
        selectionGroup.push(material);
      }
    }

    return (
      <div key={`selectionGroup_${subidx}_${idx}`} className="col-lg-12" style={{ marginBottom: '10px' }}>
        <Col key={`selectionGroup_${subidx}_${idx}_col1`} xs={11} sm={11} md={11} style={{ marginBottom: '10px' }}>
          {selectionGroup.length > 0 ? <p style={{ color: 'red' }}><b>{`${subidx + 1}. ${name}`}</b></p> : null}
        </Col>
        <Col key={`selectionGroup_${subidx}_${idx}_col2`} xs={1} sm={1} md={1} style={{ marginBottom: '10px' }}>
          {selectionGroup.length > 0 && name !== 'Godło arkusza mapy' ?
            <button
              type="submit-lg"
              className={'btn btn-danger'}
              style={{ btnStyle }}
              onClick={() => this.removeSelectionGroup(idx, name)}
            >
              Usuń
            </button> : null}
        </Col>
        {selectionGroup.map((val, index) => {
          return this.renderNonPrintedMaterialsList(idx, val, index);
        })
        }
      </div>
    );
  }

  renderNonPrintedMaterialsList = (idx, value, i) => {
    return (
      <div
        key={`NonPrinted${idx}_${i}}`}
        className="col-lg-12"
        style={(this.state.listMaterials[idx].highlightedGeoms.length > 0 && this.state.listMaterials[idx].highlightedGeoms[0].properties.name === value.properties.name) ? { backgroundColor: '#969696', marginLeft: '12px' } : { marginLeft: '12px' }}
        onMouseEnter={() => this.highlightRowAndGeom(idx, value)}
        onMouseLeave={() => this.removeHighlight(idx)}
      >
        <Col key={`selectedMaterialsList${idx}col1`} xs={4} sm={4} md={4}>
          <p style={labelStyle}><b>{`${i + 1}. ${value.properties.name}`}</b></p>
        </Col>
        <Col key={`selectedMaterialsList${idx}col2`} xs={2} sm={2} md={2}>
        </Col>
        <Col key={`selectedMaterialsList${idx}col3`} xs={5} sm={5} md={5} >
        </Col>
        <Col key={`selectedMaterialsList${idx}col4`} xs={1} sm={1} md={1} >
          {value.properties.selectionGroup === 'Godło arkusza mapy' ? <button
            type="submit-lg"
            className={'btn btn-danger'}
            style={{ btnStyle }}
            onClick={() => this.removeSelectedMaterial(idx, value.properties.name)}
          >
            Usuń
          </button> : null}
        </Col>
      </div>);
  }

  renderSharingMethods = () => {
    const check = <FiCheck style={{ width: '30px', height: '30px', color: 'green' }}/>;
    const uncheck = <FiX style={{ width: '30px', height: '30px', color: 'red' }}/>;
    return (
      <div>
        <p><b>Dostępne formy udostępnienia:</b></p>
        <p>{this.state.enabledSharingMethods.wektorowa? check : uncheck} wektorowa</p>
        <p>{this.state.enabledSharingMethods.rastrowa? check : uncheck} rastrowa</p>
        <p>{this.state.enabledSharingMethods.drukowana? check : uncheck} drukowana</p>
      </div>
    )
  }

  getMaterialPanel = (group, idx) => {
    return (
      <div>
        <p><b>Dostępne materiały zasobu:</b></p>
        <br />
        <div className="col-lg-12">
          <Col key={`materials${idx}col1`} xs={6} sm={6} md={6}>
            <p><b>Standardowe opracowania kartograficzne:</b></p>
            {this.renderMapRadioButtons(standardMaterialsOptions, group, 'selectedMaterialName', idx)}
            <br />
            <p><b>Kartograficzne opracowania tematyczne:</b></p>
            {this.renderMapRadioButtons(kartoMaterialsOptions, group, 'selectedMaterialName', idx)}
            <br />
            {this.state.otherKartoMaterialsOptions.length > 0 && <p><b>Kartograficzne opracowania tematyczne - inne:</b></p>}
            {this.state.otherKartoMaterialsOptions.length > 0 && this.renderMapRadioButtons(this.state.otherKartoMaterialsOptions, group, 'selectedMaterialName', idx)}
            <br />
          </Col>
          <Col key={`materials${idx}col2`} xs={6} sm={6} md={6}>
            <p><b>Niestandardowe opracowania topograficzne:</b></p>
            {this.renderMapRadioButtons(customMaterialsOptions, group, 'selectedMaterialName', idx)}
            <br />
            {this.state.otherCustomMaterialsOptions.length > 0 && <p><b>Niestandardowe opracowania topograficzne - inne:</b></p>}
            {this.state.otherCustomMaterialsOptions.length > 0 && this.renderMapRadioButtons(this.state.otherCustomMaterialsOptions, group, 'selectedMaterialName', idx)}
            <br />
            {this.state.otherMaterialsOptions.length > 0 && <p><b>Inne niewymienione:</b></p>}
            {this.state.otherMaterialsOptions.length > 0 && this.renderMapRadioButtons(this.state.otherMaterialsOptions, group, 'selectedMaterialName', idx)}
            <br />
          </Col>
          <Col key={`materials${idx}col3`} xs={6} sm={6} md={6} style={{ marginBottom: '-100px' }}>
            {this.state.enabledSharingMethods && this.renderSharingMethods()}
          </Col>
        </div>
        <div>
          <CustomizedMap
            id={`CustomizedMap_${idx}_${Math.random()}`}
            idx={idx}
            materialGeoms={this.state[group][idx].materialGeoms}
            selectedGeoms={this.state[group][idx].selectedMaterialsList}
            addGeomByPointIntersection={this.addGeomByPointIntersection}
            addGeomByRectangleIntersection={this.addGeomByRectangleIntersection}
            addGeomByDrawedPolyIntersection={this.addGeomByDrawedPolyIntersection}
            selectedMaterialName={this.state[group][idx].selectedMaterialName}
            highlightedGeoms={this.state[group][idx].highlightedGeoms}
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </div>
        <div className={'col-lg-12'} style={this.state[group][idx].selectionGroups.length > 0 && this.state[group][idx].selectedMaterialsList.length > 4 ? { height: '200px', overflowY: 'scroll' } : {}}>
          {this.state[group][idx].selectedMaterialsList.length > 0 ? this.renderDeletionButton(idx) : null}
          {this.state[group][idx].selectionGroups.map((name, subidx) => {
            return this.renderSelectionGroups(name, subidx, idx);
          })}
        </div>
      </div>);
  }

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });

  onHideLoading = () => this.setState({ loading: false });

  render() {
    const loadingBody =
    (<div style={{ height: '100px', ...this.state.style }}>
      <center>
        <img role="presentation" src={waiting} style={{ width: '150px', height: '150px' }} />
      </center>
      <center>
        <p>
          Proszę czekać. Trwa pobieranie danych.
        </p>
      </center>
    </div>);

    const loadingTitle = <p style={this.state.style}>Pobieranie danych...</p>;
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
      
        <ModalAlert
          title={loadingTitle}
          bodyText={loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHideLoading}
          disableButton
          removeCloseButton
          style={this.state.style}
        />
        <GrayPanel title={'Dostępność materiałów zasobu'}>
          {this.state.listMaterials.map((v, i) => {
            return (
            this.getMaterialPanel('listMaterials', i)
            );
          })}
        </GrayPanel>
        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
          </div>
        </div>
      </div>
    );
  }
}

SprDostMaterialow.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(SprDostMaterialow),
);



// WEBPACK FOOTER //
// src/routes/eservices/SprDostMaterialow.js